import Policy from "pages/LandingPages/Policy";

export default function PolicyPage() {
  return <Policy />;
}